import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SVGElement from './SVGElement';
import colors from '../../styling/colors';

export default class CheckmarkCircle16 extends Component {
  static propTypes = {
    className: PropTypes.string,
    height: PropTypes.string,
    strokeColor: PropTypes.string,
    width: PropTypes.string,
  };

  static defaultProps = {
    height: '1rem',
    strokeColor: colors('lapel'),
    width: '1rem',
  };

  render() {
    const { className, height, strokeColor, width } = this.props;
    return (
      <SVGElement
        className={className}
        height={height}
        width={width}
        viewBox="0 0 16 16"
      >
        <path
          fill={strokeColor}
          fillRule="nonzero"
          clipRule="evenodd"
          d="M16 8c0 4.4-3.6 8-8 8s-8-3.6-8-8 3.6-8 8-8 8 3.6 8 8zm-1 0c0-3.9-3.1-7-7-7S1 4.1 1 8s3.1 7 7 7 7-3.1 7-7zm-8.4 3.4L4.1 8.9c-.4-.5.3-1.2.8-.8L7 10.2l4.2-5.5c.4-.5 1.2.1.8.6l-4.5 6c-.3.3-.6.3-.9.1z"
        />
      </SVGElement>
    );
  }
}
